import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import PageTracker from "components/PageTracker/PageTracker";
import Switch from "./Switch";

type Props = {};

class Router extends React.Component<Props> {
  render() {
    return (
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path="*" element={<PageTracker />} />
        </Routes>
        <Switch />
      </HashRouter>
    );
  }
}

export default Router;
